import { AUTOSAVE_IDLE_CALLBACK_TIMEOUT_MS } from '@/drafting/constants';
import type { BrowserIdleCallbackHandle } from '@/drafting/types';

export const scheduleBrowserIdleCallback = (callback: () => void): BrowserIdleCallbackHandle => {
  const browserWindow = window as Window & {
    requestIdleCallback?: (callback: () => void, options?: { timeout?: number }) => number;
  };
  if (typeof browserWindow.requestIdleCallback === 'function') {
    return {
      id: browserWindow.requestIdleCallback(callback, { timeout: AUTOSAVE_IDLE_CALLBACK_TIMEOUT_MS }),
      type: 'idle',
    };
  }

  return {
    id: window.setTimeout(callback, 0),
    type: 'timeout',
  };
};

export const cancelBrowserIdleCallback = (handle: BrowserIdleCallbackHandle) => {
  const browserWindow = window as Window & {
    cancelIdleCallback?: (id: number) => void;
  };
  if (handle.type === 'idle' && typeof browserWindow.cancelIdleCallback === 'function') {
    browserWindow.cancelIdleCallback(handle.id);
    return;
  }

  window.clearTimeout(handle.id);
};
